module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0044.jpg?v=8d5ac9a4";